<template>
  <b-button
    class="eBtn"
    :class="{ [`${variant}Btn`]: true, dense: dense }"
    :size="dense ? 'sm' : ''"
    v-on="$listeners"
  >
    <BaseIcon v-if="preIcon" :name="preIcon" class="mx-1" />
    <slot />
    <BaseIcon v-if="icon" :name="icon" class="mx-1" />
  </b-button>
</template>
<script>
export default {
  props: {
    variant: { type: String, default: () => 'primary' },
    preIcon: { type: String, default: () => null },
    icon: { type: String, default: () => null },
    dense: { type: Boolean, default: false },
  },
}
</script>
<style lang="scss" scoped>
@import '@design';

.eBtn {
  min-width: 120px;
  font-weight: 500 !important;
  cursor: pointer;
  border: 1px solid $color-link-text-active;
  border-radius: 2px;
  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }
}
.eBtn:hover {
  background-color: $color-text-gray !important;
}

*.eBtn:not(:nth-child(1)) {
  margin-left: 1rem;
}

.iconBtn,
.cancelBtn {
  color: $color-link-text-active;
  background-color: $color-content-bg !important;
}
.iconBtn:hover,
.cancelBtn:hover {
  background-color: rgb(231, 229, 229) !important;
}

.iconBtn {
  width: auto;
  min-width: auto;
  padding-left: 0.85rem;
  padding-right: 0.85rem;
  border: $input-border;
}

.dense {
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
}

.primaryBtn {
  color: $color-button-text;
  background-color: $color-button-bg !important;

  .svg-inline--fa {
    color: #fff;
  }
}
.primaryBtn:hover {
  color: $color-button-text;
  background-color: $color-text-gray !important;
}
</style>
